import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function FinalCTA() {
  return <section className="w-full py-24 md:py-32 px-6 flex justify-center bg-carbon border-t border-border/50" data-id="element-14">
      <div className="max-w-4xl w-full text-center flex flex-col items-center" data-id="element-15">
        <motion.h2 className="text-gold text-3xl sm:text-4xl lg:text-5xl font-bold mb-12 leading-tight" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} data-id="element-16">
          Tu flota debería estar trabajando todos los días. No solo en verano.
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5,
        delay: 0.2,
        ease: 'easeOut'
      }} className="w-full sm:w-auto" data-id="element-17">
          <CTAButton className="w-full sm:w-auto" data-id="element-18">
            LLENA MI CALENDARIO DE MUDANZAS
          </CTAButton>
        </motion.div>
      </div>
    </section>;
}